(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7568],{

/***/ 96880:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ BlogDetailPage; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./styles/newspressdetails.module.scss
var newspressdetails_module = __webpack_require__(16083);
var newspressdetails_module_default = /*#__PURE__*/__webpack_require__.n(newspressdetails_module);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Container.js
var Container = __webpack_require__(10682);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Row.js
var Row = __webpack_require__(34051);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Breadcrumb.js + 1 modules
var Breadcrumb = __webpack_require__(26699);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Col.js
var Col = __webpack_require__(31555);
// EXTERNAL MODULE: ./components/CustomImage.tsx
var CustomImage = __webpack_require__(45992);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/format/index.js + 4 modules
var format = __webpack_require__(42298);
// EXTERNAL MODULE: ./utils/fetchUtil.ts
var fetchUtil = __webpack_require__(40607);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Overlay.js + 62 modules
var Overlay = __webpack_require__(78487);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Tooltip.js
var Tooltip = __webpack_require__(43489);
// EXTERNAL MODULE: ./utils/helpers.ts + 1 modules
var helpers = __webpack_require__(32866);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./components/LazyReveal.tsx
var LazyReveal = __webpack_require__(70710);
// EXTERNAL MODULE: ./components/Shimmer/index.tsx
var Shimmer = __webpack_require__(76663);
// EXTERNAL MODULE: ./components/Shimmer/ShimmerItem.tsx
var ShimmerItem = __webpack_require__(90252);
;// CONCATENATED MODULE: ./components/BlogShimmer.tsx



function BlogShimmer() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "p-3 w-100%",
        children: [
            [
                ...Array(3)
            ].map((_, i)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)(Shimmer/* default */.Z, {
                    gap: "8px",
                    direction: "column",
                    className: "mb-2",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ShimmerItem/* default */.Z, {
                            height: "16px",
                            width: "100%"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ShimmerItem/* default */.Z, {
                            height: "16px",
                            width: "90%"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ShimmerItem/* default */.Z, {
                            height: "16px",
                            width: "80%"
                        })
                    ]
                }, `para-top-${i}`)),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ShimmerItem/* default */.Z, {
                height: "280px",
                width: "100%",
                className: "mb-2"
            }),
            [
                ...Array(3)
            ].map((_, i)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)(Shimmer/* default */.Z, {
                    gap: "8px",
                    direction: "column",
                    className: "mb-2",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ShimmerItem/* default */.Z, {
                            height: "16px",
                            width: "95%"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ShimmerItem/* default */.Z, {
                            height: "16px",
                            width: "85%"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ShimmerItem/* default */.Z, {
                            height: "16px",
                            width: "70%"
                        })
                    ]
                }, `para-mid-${i}`)),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Shimmer/* default */.Z, {
                gap: "8px",
                direction: "column",
                className: "mb-2",
                children: [
                    ...Array(7)
                ].map((_, rowIndex)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)(Shimmer/* default */.Z, {
                        gap: "8px",
                        direction: "row",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ShimmerItem/* default */.Z, {
                                height: "20px",
                                width: "30%"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ShimmerItem/* default */.Z, {
                                height: "20px",
                                width: "30%"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ShimmerItem/* default */.Z, {
                                height: "20px",
                                width: "30%"
                            })
                        ]
                    }, `row-${rowIndex}`))
            }),
            [
                ...Array(2)
            ].map((_, i)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)(Shimmer/* default */.Z, {
                    gap: "8px",
                    direction: "column",
                    className: "mb-2",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ShimmerItem/* default */.Z, {
                            height: "16px",
                            width: "100%"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ShimmerItem/* default */.Z, {
                            height: "16px",
                            width: "85%"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ShimmerItem/* default */.Z, {
                            height: "16px",
                            width: "60%"
                        })
                    ]
                }, `para-bottom-${i}`))
        ]
    });
}

// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Card.js + 2 modules
var Card = __webpack_require__(78182);
// EXTERNAL MODULE: ./node_modules/react-slick/lib/index.js
var lib = __webpack_require__(46066);
// EXTERNAL MODULE: ./utils/constants.ts
var constants = __webpack_require__(59830);
// EXTERNAL MODULE: ./components/BlogDetailPage/CardShimmer.module.scss
var CardShimmer_module = __webpack_require__(37948);
var CardShimmer_module_default = /*#__PURE__*/__webpack_require__.n(CardShimmer_module);
;// CONCATENATED MODULE: ./components/BlogDetailPage/CardShimmer.tsx
"use client";





function CardShimmer({ count: cardCount = 3 , direction ="row"  }) {
    const { 0: count , 1: setCount  } = (0,react.useState)(cardCount);
    (0,react.useEffect)(()=>{
        const updateCount = ()=>{
            setCount(window.innerWidth < 700 ? 1 : cardCount);
        };
        updateCount();
        window.addEventListener("resize", updateCount);
        return ()=>window.removeEventListener("resize", updateCount);
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Shimmer/* default */.Z, {
        gap: "1rem",
        direction: direction,
        justify: "center",
        align: "start",
        className: "w-100",
        children: Array.from({
            length: count
        }).map((_, idx)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)(Shimmer/* default */.Z, {
                className: (CardShimmer_module_default()).card,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ShimmerItem/* default */.Z, {
                        width: "100%",
                        height: "220px",
                        className: `${(CardShimmer_module_default()).image} mb-2`
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ShimmerItem/* default */.Z, {
                        width: "30%",
                        height: "16px",
                        className: "mb-1"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ShimmerItem/* default */.Z, {
                        width: "80%",
                        height: "20px",
                        className: "mb-2"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Shimmer/* default */.Z, {
                        gap: "0.25rem",
                        direction: "column",
                        className: "mb-2",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ShimmerItem/* default */.Z, {
                                width: "90%",
                                height: "14px"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ShimmerItem/* default */.Z, {
                                width: "85%",
                                height: "14px"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ShimmerItem/* default */.Z, {
                                width: "70%",
                                height: "14px"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ShimmerItem/* default */.Z, {
                        width: "40%",
                        height: "14px"
                    })
                ]
            }, idx))
    });
}

// EXTERNAL MODULE: ./node_modules/slick-carousel/slick/slick.css
var slick = __webpack_require__(98322);
// EXTERNAL MODULE: ./node_modules/slick-carousel/slick/slick-theme.css
var slick_theme = __webpack_require__(98745);
;// CONCATENATED MODULE: ./components/BlogDetailPage/NewsList.tsx










const NewsList = ({ sliderSettings , styles , detailData , pathCondition , latestNews =[] , isLoading , onVisible ,  })=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(LazyReveal/* default */.Z, {
        shimmer: /*#__PURE__*/ (0,jsx_runtime.jsx)(CardShimmer, {}),
        onVisible: onVisible,
        rootMargin: "100px",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: isLoading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CardShimmer, {}) : latestNews.length > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(lib/* default */.Z, {
                ...sliderSettings,
                slidesToShow: latestNews.length < 3 ? latestNews.length : 3,
                children: latestNews.map((blog, index)=>{
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: styles.allnews,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                            className: "text-center",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: detailData.isExternalLink && detailData.externalLink ? detailData.externalLink : `/${pathCondition ? "news" : "blogs"}/${blog.slug}`,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                    lg: 12,
                                    md: 12,
                                    sm: 12,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card/* default */.Z, {
                                        className: styles.card,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: styles.cardImg,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                                    src: blog.newimageUrl?.imageUrl,
                                                    alt: blog.newimageUrl?.alt,
                                                    width: 370,
                                                    height: 220,
                                                    "object-fit": "fill"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card/* default.Body */.Z.Body, {
                                                className: styles.cardBody,
                                                children: [
                                                    blog.category && /*#__PURE__*/ (0,jsx_runtime.jsx)("h6", {
                                                        className: styles.blogsCategories,
                                                        children: blog.category
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                                                        children: blog.title
                                                    }),
                                                    blog.shortDescription && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        className: styles.shortDescription,
                                                        children: blog.shortDescription
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: styles.bottom,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            children: (0,format["default"])(new Date(blog.date), constants/* formatOrder */.iV)
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                })
                            })
                        })
                    }, index);
                })
            }) : "No Related News"
        })
    });
};
/* harmony default export */ var BlogDetailPage_NewsList = (NewsList);

;// CONCATENATED MODULE: ./components/BlogDetailPage/BlogsList.tsx












const BlogsList = ({ detailData , styles , pathCondition , settings ,  })=>{
    const { 0: latestBlogs , 1: setLatestBlogs  } = (0,react.useState)([]);
    const { 0: isLoading , 1: setIsLoading  } = (0,react.useState)(false);
    const sliderRef = (0,react.useRef)(null);
    const { 0: isVisible , 1: setIsVisible  } = (0,react.useState)(false);
    const onVisible = (0,react.useCallback)(()=>{
        setIsVisible(true);
    }, []);
    (0,react.useEffect)(()=>{
        if (!isVisible) {
            return;
        }
        setIsLoading(true);
        (0,fetchUtil/* default */.Z)(`${"https://cms.studies-overseas.com"}/blogs?_sort=date:DESC&_start=0&stu_dest_categories.category_ncontains=News&_limit=20`, "GET", {}, "", false).then((res)=>{
            setLatestBlogs(res);
            setIsLoading(false);
        });
    }, [
        isVisible
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(LazyReveal/* default */.Z, {
        shimmer: /*#__PURE__*/ (0,jsx_runtime.jsx)(CardShimmer, {}),
        onVisible: onVisible,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                isLoading && /*#__PURE__*/ (0,jsx_runtime.jsx)(CardShimmer, {}),
                !isLoading && (latestBlogs.length > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(lib/* default */.Z, {
                            ...settings,
                            slidesToShow: latestBlogs.length < 3 ? latestBlogs.length : 3,
                            ref: sliderRef,
                            className: `${styles.slider} ${styles.mobileCultureSlider}`,
                            children: latestBlogs.map((blog, index)=>{
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: styles.allnews,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                                        className: "text-center",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            href: detailData.isExternalLink && detailData.externalLink ? detailData.externalLink : `/${pathCondition ? "news" : "blogs"}/${blog.slug}`,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                                lg: 12,
                                                md: 12,
                                                sm: 12,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card/* default */.Z, {
                                                    className: styles.card,
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: styles.cardImg,
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                                                src: blog.blogLandingCardImage?.imageUrl ? blog.blogLandingCardImage.imageUrl : blog.newimageUrl?.imageUrl,
                                                                alt: blog.blogLandingCardImage?.alt ? blog.blogLandingCardImage.alt : blog.newimageUrl?.alt,
                                                                width: 370,
                                                                height: 220,
                                                                "object-fit": "fill",
                                                                layout: "responsive"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card/* default.Body */.Z.Body, {
                                                            className: styles.cardBody,
                                                            children: [
                                                                blog.category && /*#__PURE__*/ (0,jsx_runtime.jsx)("h6", {
                                                                    className: styles.blogsCategories,
                                                                    children: blog.category
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                                                                    children: blog.title
                                                                }),
                                                                blog.shortDescription && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                    className: styles.shortDescription,
                                                                    children: blog.shortDescription
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: styles.bottom,
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                        children: (0,format["default"])(new Date(blog.date), constants/* formatOrder */.iV)
                                                                    })
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            })
                                        })
                                    })
                                }, index);
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: styles.arrowsClasses,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: styles.btcircle,
                                    onClick: ()=>sliderRef?.current?.slickPrev(),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                        src: "/new-images/left-arrow.svg",
                                        height: 17,
                                        width: 10,
                                        alt: "left-arrow"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: styles.btcircle,
                                    onClick: ()=>sliderRef?.current?.slickNext(),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                        src: "/new-images/right-arrow.svg",
                                        height: 17,
                                        width: 10,
                                        alt: "right-arrow"
                                    })
                                })
                            ]
                        })
                    ]
                }) : "No Related Blogs")
            ]
        })
    });
};
/* harmony default export */ var BlogDetailPage_BlogsList = (BlogsList);

// EXTERNAL MODULE: ./components/EnquiryModal/LeadGenForms.tsx + 2 modules
var LeadGenForms = __webpack_require__(59833);
// EXTERNAL MODULE: ./node_modules/react-share/es/WhatsappShareButton.js
var WhatsappShareButton = __webpack_require__(12834);
// EXTERNAL MODULE: ./node_modules/react-share/es/FacebookShareButton.js
var FacebookShareButton = __webpack_require__(16573);
// EXTERNAL MODULE: ./node_modules/react-share/es/LinkedinShareButton.js
var LinkedinShareButton = __webpack_require__(53597);
// EXTERNAL MODULE: ./node_modules/react-share/es/TwitterShareButton.js
var TwitterShareButton = __webpack_require__(46616);
;// CONCATENATED MODULE: ./components/InstagramShareButton.tsx


const InstagramShareButton = ({ url , children , ...props })=>{
    const handleClick = (e)=>{
        e.preventDefault();
        window.open("https://www.instagram.com/kcoverseasofficial/", "_blank", "noopener,noreferrer");
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
        href: "https://www.instagram.com/kcoverseasofficial/",
        onClick: handleClick,
        style: {
            display: "inline-block",
            cursor: "pointer",
            textDecoration: "none"
        },
        ...props,
        children: children
    });
};
/* harmony default export */ var components_InstagramShareButton = (InstagramShareButton);

;// CONCATENATED MODULE: ./components/SocialShareButtons.tsx






const SocialShareButtons = ({ currentUrl  })=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(WhatsappShareButton/* default */.Z, {
                    url: currentUrl,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (newspressdetails_module_default()).centerIcon,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                            src: "/new-images/whats-app.svg",
                            width: 36,
                            height: 36,
                            alt: "WhatsApp"
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FacebookShareButton/* default */.Z, {
                    url: currentUrl,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (newspressdetails_module_default()).centerIcon,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                            src: "/new-images/face-book.svg",
                            width: 36,
                            height: 36,
                            alt: "Facebook"
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_InstagramShareButton, {
                    url: currentUrl,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (newspressdetails_module_default()).centerIcon,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                            src: "/new-images/insta.svg",
                            width: 36,
                            height: 36,
                            alt: "Instagram"
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkedinShareButton/* default */.Z, {
                    url: currentUrl,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (newspressdetails_module_default()).centerIcon,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                            src: "/new-images/linkedin-icon-a.svg",
                            width: 36,
                            height: 36,
                            alt: "LinkedIN"
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TwitterShareButton/* default */.Z, {
                    url: currentUrl,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (newspressdetails_module_default()).centerIcon,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                            src: "/new-images/twitter.svg",
                            width: 36,
                            height: 36,
                            alt: "Twitter"
                        })
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var components_SocialShareButtons = (SocialShareButtons);

;// CONCATENATED MODULE: ./components/AdvertisementSection.tsx



const AdvertisementSection = ({ matchedAdvertisement , isMobile  })=>{
    if (!matchedAdvertisement) {
        return null;
    }
    const { url , link  } = matchedAdvertisement;
    if (isMobile) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "advertisement",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "box",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        href: link,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                            src: url,
                            alt: "Advertisement",
                            width: 500,
                            height: 500,
                            "object-fit": "fill"
                        })
                    })
                })
            })
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "advertisement",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "box",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    href: link,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                        src: url,
                        alt: "Advertisement",
                        width: 334,
                        height: 326
                    })
                })
            })
        })
    });
};
/* harmony default export */ var components_AdvertisementSection = (AdvertisementSection);

;// CONCATENATED MODULE: ./components/RelatedBlogs.tsx





const RelatedBlogs = ({ categoryBlogs , pathCondition , detailData , styles  })=>{
    if (pathCondition || categoryBlogs.length === 0) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: styles.new,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                    className: styles.headingBlogs,
                    children: "Related Blogs"
                }),
                categoryBlogs.map((blog, index)=>{
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: `${styles.allnews} ${styles.relatedBlogsBox}`,
                        children: blog.newimageUrl && /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            href: detailData.isExternalLink && detailData.externalLink ? detailData.externalLink : `/${pathCondition ? "news" : "blogs"}/${blog.slug}`,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: styles.card,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: styles.relatedBlogImg,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                            src: blog.newimageUrl?.imageUrl,
                                            alt: blog.newimageUrl?.alt,
                                            width: 370,
                                            height: 155,
                                            "object-fit": "fill",
                                            layout: "responsive"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: styles.cardBody,
                                        children: [
                                            blog.category && /*#__PURE__*/ (0,jsx_runtime.jsx)("h6", {
                                                className: styles.blogsCategories,
                                                children: blog.category
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                                                children: blog.title
                                            }),
                                            blog.shortDescription && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: styles.shortDescription,
                                                children: blog.shortDescription
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                children: (0,format["default"])(new Date(blog.date), constants/* formatOrder */.iV)
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    }, index);
                })
            ]
        })
    });
};
/* harmony default export */ var components_RelatedBlogs = (RelatedBlogs);

// EXTERNAL MODULE: ./components/NeedGuidance.tsx
var NeedGuidance = __webpack_require__(84623);
;// CONCATENATED MODULE: ./hooks/useSmoothScroll.ts

/**
 * web-539 fix for scroll - Custom hook for Table of Contents smooth scrolling
 * Prevents TOC links from opening in new tab, instead smooth scrolls to sections
 * Updates browser URL with hash on click and handles initial hash on page load
 * 
 * @param contentSelector - CSS selector for the main content container (e.g., '.blogDetails')
 * @param tocSelector - CSS selector for the TOC container (e.g., '#sanitizedHeroContent')
 * @param dependencies - Array of dependencies to re-run the effect (e.g., [slug, description])
 */ const useSmoothScroll = (contentSelector = ".blogDetails", tocSelector = "#sanitizedHeroContent", dependencies = [])=>{
    (0,react.useEffect)(()=>{
        // web-539 fix for scroll - Generate unique IDs for headings (h2) in content
        const generateUniqueIds = ()=>{
            const answerParagraphs = document.querySelectorAll(`${contentSelector} h2`);
            if (answerParagraphs.length === 0) return; // wait for content to load
            answerParagraphs.forEach((paragraph, index)=>{
                if (paragraph.hasAttribute("id")) return; // don't override an existing id
                const id = `answer_${index}`;
                paragraph.setAttribute("id", id);
            });
        };
        // web-539 fix for scroll - Smooth scroll to target section
        const scrollToTarget = (targetSelector, updateUrl = true)=>{
            const hash = targetSelector.startsWith("#") ? targetSelector.slice(1) : targetSelector;
            const targetElement = document.getElementById(hash);
            if (targetElement) {
                const topOffset = targetElement.getBoundingClientRect().top;
                const offsetY = window.pageYOffset || document.documentElement.scrollTop;
                const targetTop = topOffset + offsetY - 100; // 100px offset for fixed header
                window.scroll({
                    top: targetTop,
                    behavior: "smooth"
                });
                // web-539 fix for scroll - Update browser URL with hash
                if (updateUrl) {
                    const newUrl = `${window.location.pathname}${window.location.search}#${hash}`;
                    window.history.pushState({}, "", newUrl);
                }
            }
        };
        // web-539 fix for scroll - Global click handler to intercept anchor clicks
        const handleClick = (e)=>{
            const target = e.target;
            const anchor = target.closest("a");
            if (!anchor) return;
            // Check if this anchor is inside content or TOC
            const inContent = anchor.closest(contentSelector) || anchor.closest(tocSelector);
            if (!inContent) return;
            const href = anchor.getAttribute("href") || anchor.href || "";
            // Extract hash from href
            let hash = "";
            try {
                if (href.startsWith("#")) {
                    hash = href;
                } else if (href.includes("#")) {
                    const hashIndex = href.indexOf("#");
                    const potentialHash = href.substring(hashIndex);
                    const urlWithoutHash = href.substring(0, hashIndex);
                    const currentUrl = window.location.href.split("#")[0];
                    if (!urlWithoutHash || urlWithoutHash === currentUrl || urlWithoutHash === window.location.pathname) {
                        hash = potentialHash;
                    }
                }
            } catch (err) {
            // Invalid URL, skip
            }
            if (hash) {
                e.preventDefault();
                e.stopPropagation();
                e.stopImmediatePropagation();
                scrollToTarget(hash, true); // Update URL on click
                return false;
            }
        };
        // web-539 fix for scroll - Attach global click handler with capture
        document.addEventListener("click", handleClick, true);
        // web-539 fix for scroll - Normalize anchors (set proper href for hover preview, remove target="_blank")
        const normalizeAnchors = ()=>{
            const anchors = Array.from(document.querySelectorAll(`${contentSelector} a[href*='#'], ${tocSelector} a[href*='#']`));
            anchors.forEach((anchor)=>{
                const href = anchor.getAttribute("href") || "";
                // Extract hash from href
                let hash = "";
                try {
                    if (href.startsWith("#")) {
                        hash = href;
                    } else if (href.includes("#")) {
                        const hashIndex = href.indexOf("#");
                        hash = href.substring(hashIndex);
                    }
                } catch (err) {
                // Invalid URL, skip
                }
                // web-539 fix for scroll - Set href to relative hash path so browser shows it on hover
                if (hash) {
                    anchor.setAttribute("href", hash);
                }
                // Remove target and rel attributes
                anchor.removeAttribute("target");
                anchor.removeAttribute("rel");
            });
        };
        // web-539 fix for scroll - Setup with multiple attempts for lazy-loaded content
        const setupScrolling = ()=>{
            generateUniqueIds();
            normalizeAnchors();
        };
        // web-539 fix for scroll - Run setup immediately on mount (not just with delays)
        // This ensures anchors are normalized before user can click them on first page load
        setupScrolling();
        // web-539 fix for scroll - Handle initial hash on page load
        const handleInitialHash = ()=>{
            if (!window.location.hash) return;
            const hash = window.location.hash;
            const hashId = hash.startsWith("#") ? hash.slice(1) : hash;
            // Ensure IDs are generated first
            generateUniqueIds();
            // Check if target element exists
            const targetElement = document.getElementById(hashId);
            if (targetElement) {
                // Element found, scroll to it (don't update URL, it's already there)
                scrollToTarget(hash, false);
            }
        };
        // web-539-v2 fix for scroll - Listen for hash changes (manual URL edits, back/forward navigation)
        const handleHashChange = ()=>{
            if (window.location.hash) {
                // Generate IDs first
                generateUniqueIds();
                // Small delay to ensure content is ready
                setTimeout(()=>{
                    const hash = window.location.hash;
                    const hashId = hash.startsWith("#") ? hash.slice(1) : hash;
                    const targetElement = document.getElementById(hashId);
                    if (targetElement) {
                        scrollToTarget(hash, false);
                    }
                }, 100);
            }
        };
        // Run immediately and at intervals to catch lazy-loaded content
        const timeouts = [
            100,
            500,
            1000,
            2000,
            3000
        ].map((delay)=>setTimeout(setupScrolling, delay));
        // web-539-v2 fix for scroll - Attach hashchange listener
        window.addEventListener("hashchange", handleHashChange);
        // web-539 fix for scroll - Try to handle initial hash at intervals (for lazy-loaded content)
        const initialHashTimeouts = [];
        if (window.location.hash) {
            // web-539-v2 fix for scroll - Try immediately on mount (no delay)
            setupScrolling();
            handleInitialHash();
            // web-539-v2 fix for scroll - Then retry at intervals for lazy-loaded content (extended to 7s)
            [
                200,
                500,
                1000,
                1500,
                2000,
                3000,
                4000,
                5000,
                6000,
                7000
            ].forEach((delay)=>{
                initialHashTimeouts.push(setTimeout(()=>{
                    setupScrolling(); // Ensure IDs are generated
                    handleInitialHash();
                }, delay));
            });
        }
        // web-539 fix for scroll - Watch for content changes (LazyReveal / dynamic content)
        const observerTargets = [
            document.querySelector(contentSelector),
            document.querySelector(tocSelector)
        ].filter(Boolean);
        const observer = observerTargets.length > 0 ? new MutationObserver(()=>{
            setupScrolling();
            // Re-check for hash after content changes (for lazy-loaded content)
            if (window.location.hash) {
                handleInitialHash();
            }
        }) : null;
        if (observer) {
            observerTargets.forEach((el)=>observer.observe(el, {
                    childList: true,
                    subtree: true
                }));
        }
        // web-539 fix for scroll - Cleanup on unmount or dependency change
        return ()=>{
            timeouts.forEach(clearTimeout);
            initialHashTimeouts.forEach(clearTimeout);
            document.removeEventListener("click", handleClick, true);
            window.removeEventListener("hashchange", handleHashChange); // web-539-v2 fix for scroll
            if (observer) {
                observer.disconnect();
            }
        };
    }, dependencies);
};

// EXTERNAL MODULE: ./hooks/useIsMobile.tsx
var useIsMobile = __webpack_require__(14523);
// EXTERNAL MODULE: ./utils/applyCtaButtonProps.ts
var utils_applyCtaButtonProps = __webpack_require__(78409);
// EXTERNAL MODULE: ./utils/b2c/constants.ts
var b2c_constants = __webpack_require__(90017);
// EXTERNAL MODULE: ./utils/b2c/sourceTracking.ts
var sourceTracking = __webpack_require__(3265);
// EXTERNAL MODULE: ./components/News/LatestNews.module.scss
var LatestNews_module = __webpack_require__(88526);
var LatestNews_module_default = /*#__PURE__*/__webpack_require__.n(LatestNews_module);
;// CONCATENATED MODULE: ./components/News/LatestNews.tsx






const LatestNews = ({ latestNews =[] , isLoading  })=>{
    if (!isLoading && latestNews.length === 0) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (LatestNews_module_default())["latest-news-container"],
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                className: (LatestNews_module_default())["latest-news-heading"],
                children: "Latest News"
            }),
            latestNews.map((news, index)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                    className: (LatestNews_module_default())["latest-news-card"],
                    href: `/news/${news.slug}`,
                    children: [
                        news.newimageUrl && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (LatestNews_module_default())["latest-news-image"],
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                src: news.newimageUrl?.imageUrl,
                                alt: news.newimageUrl?.alt,
                                layout: "fill",
                                objectFit: "fill"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (LatestNews_module_default())["latest-news-body"],
                            children: [
                                news.category && /*#__PURE__*/ (0,jsx_runtime.jsx)("h6", {
                                    className: (LatestNews_module_default())["latest-news-category"],
                                    children: news.category
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                                    children: news.title
                                }),
                                news.shortDescription && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: (LatestNews_module_default())["latest-news-description"],
                                    children: news.shortDescription
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: (LatestNews_module_default())["latest-news-date"],
                                    children: (0,format["default"])(new Date(news.date), constants/* formatOrder */.iV)
                                })
                            ]
                        })
                    ]
                }, index))
        ]
    });
};
/* harmony default export */ var News_LatestNews = (LatestNews);

;// CONCATENATED MODULE: ./hooks/useLatestNews.tsx


const useLatestNews = (enabled, excludeId)=>{
    const { 0: latestNews , 1: setLatestNews  } = (0,react.useState)([]);
    const { 0: isLoading , 1: setIsLoading  } = (0,react.useState)(false);
    (0,react.useEffect)(()=>{
        if (!enabled) {
            return;
        }
        setIsLoading(true);
        (0,fetchUtil/* default */.Z)(`${"https://cms.studies-overseas.com"}/blogs?_sort=date:DESC&_start=0&stu_dest_categories.category=News`, "GET", {}, "", false).then((res)=>{
            setLatestNews(res);
            setIsLoading(false);
        });
    }, [
        enabled
    ]);
    const filteredNews = (0,react.useMemo)(()=>excludeId == null ? latestNews : latestNews.filter((news)=>news?.id !== excludeId), [
        latestNews,
        excludeId
    ]);
    return {
        latestNews: filteredNews,
        isLoading
    };
};
/* harmony default export */ var hooks_useLatestNews = (useLatestNews);

// EXTERNAL MODULE: ./components/universityDetail/IntroAd/IntroAd.tsx
var IntroAd = __webpack_require__(41472);
// EXTERNAL MODULE: ./components/UI/PrefSrcButton/PrefSrcButton.tsx + 1 modules
var PrefSrcButton = __webpack_require__(20283);
;// CONCATENATED MODULE: ./components/BlogDetailPage.tsx
























 // web-539 fix for scroll








const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToScroll: 1,
    autoplay: true,
    cssEase: "linear",
    pauseOnHover: true,
    arrows: false,
    responsive: [
        {
            breakpoint: 767,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1
            }
        }, 
    ]
};
const NewsAndPressDetailPage = (props)=>{
    const target = (0,react.useRef)(null);
    const router = (0,next_router.useRouter)();
    const isMobile = (0,useIsMobile/* default */.Z)(768);
    const { 0: isCopied , 1: setIsCopied  } = (0,react.useState)(false);
    const detailData = props.pageData[0];
    const categoryPageDataAdvertisement = props.categoryData;
    const { 0: categoryBlogs , 1: setCategoryBlogs  } = (0,react.useState)([]);
    const { 0: matchedAdvertisement , 1: setMatchedAdvertisement  } = (0,react.useState)(null);
    const { 0: introAd , 1: setIntroAd  } = (0,react.useState)({});
    const sanitizedContent = detailData.description.replace(/&nbsp;/g, " ");
    const pathCondition = router.pathname.includes("/news/");
    const { 0: isLatestNewsVisible , 1: setIsLatestNewsVisible  } = (0,react.useState)(false);
    const onLatestNewsVisible = (0,react.useCallback)(()=>{
        setIsLatestNewsVisible(true);
    }, []);
    const { latestNews , isLoading: isLatestNewsLoading  } = hooks_useLatestNews(pathCondition && isLatestNewsVisible, detailData?.id);
    (0,react.useEffect)(()=>{
        const blogCategory = detailData?.stu_dest_categories[0]?.category;
        const coaching = detailData?.coachingCategory;
        const successStories = detailData?.successStoriesCategory;
        const recruiters = detailData?.forRecruiters;
        const categoryCondition = blogCategory ? `&stu_dest_categories.category_contains=${blogCategory}` : "";
        const courseCondition = detailData?.course ? `&course=${detailData.course}` : "";
        const coachingCondition = coaching ? `&coachingCategory=${coaching}` : "";
        const successStoriesCondition = successStories ? `&successStoriesCategory=${successStories}` : "";
        const recruiterCondition = recruiters ? `&forRecruiters=${recruiters}` : "";
        const limitCondition = "&_limit=2";
        const currentSlug = detailData?.slug;
        if (detailData?.categories && Array.isArray(categoryPageDataAdvertisement)) {
            detailData?.categories.forEach((detailCategory)=>{
                const matchedCategory = categoryPageDataAdvertisement.find((category)=>category.id === detailCategory.id);
                if (matchedCategory && matchedCategory.advertisement) {
                    const advertisementImageUrl = matchedCategory.advertisement.advertisementImage?.url;
                    const advertisementLink = matchedCategory.advertisement.link;
                    setIntroAd(matchedCategory.advertisement?.introAd ?? {});
                    if (advertisementImageUrl) {
                        setMatchedAdvertisement({
                            url: advertisementImageUrl,
                            link: advertisementLink
                        });
                    }
                }
            });
        }
        (0,fetchUtil/* default */.Z)(`${"https://cms.studies-overseas.com"}/blogs?_sort=date:DESC&_start=0&stu_dest_categories.category_ncontains=News&slug_ncontains=${currentSlug}${limitCondition}${categoryCondition}${courseCondition}${coachingCondition}${successStoriesCondition}${recruiterCondition}`, "GET", {}, "", false).then((res)=>{
            setCategoryBlogs(res);
        });
    }, [
        categoryPageDataAdvertisement
    ]);
    // web-539 fix for scroll - Use smooth scroll hook for Table of Contents
    // Re-runs when blog content changes (navigation between blogs)
    useSmoothScroll(".blogDetails", "#sanitizedHeroContent", [
        detailData?.slug,
        detailData?.description
    ]);
    const formatDate = (date)=>(0,format["default"])(new Date(date), "LLL dd, yyyy");
    const currentUrl = `${"https://www.studies-overseas.com"}${router.asPath}`;
    const onClickCopy = ()=>{
        navigator.clipboard.writeText(currentUrl);
        setIsCopied(true);
    };
    const applyCtaButtonProps = (0,utils_applyCtaButtonProps/* getOnboardingOrFormCtaProps */.J)(router, {
        btnLink: detailData?.blogCtaButton?.link,
        formId: detailData?.blogCtaButton?.formId,
        formKeyFromEnv: "blogs-open-enquiry-form-detailed-blogs-pages",
        toOnboardingEnabled: detailData?.blogCtaButton?.toOnboardingEnabled,
        sourceUrl:  true ? window.location.pathname : 0
    });
    const ctaBtnClickHandler = (applyCtaButtonProps)=>(e)=>{
            if (applyCtaButtonProps.mode === "onboarding") {
                (0,sourceTracking/* persistSourceContext */.jW)({
                    sourceUrl: window.location.href,
                    primarySource: b2c_constants/* PRIMARY_SOURCE_B2C_WIDGET */.ov,
                    fifthStepVisible: detailData?.blogCtaButton?.nearestOffice ?? true,
                    coachingVisible: detailData?.blogCtaButton?.lookingForCoaching ?? true
                });
            }
            applyCtaButtonProps.onClick?.(e);
        };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "preload",
                        as: "image",
                        href: detailData?.imageUrl || "/images/girl.png",
                        imageSrcSet: `${(0,helpers/* getMobileImageUrl */.w9)(detailData?.imageUrl) || "/images/girl.png"} 640w`,
                        imageSizes: "(max-width: 767px) 640px, 100vw",
                        fetchPriority: "high"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        href: "/images/newsandpress/abt-bg-star.svg",
                        rel: "preload",
                        as: "image",
                        fetchpriority: "high"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (newspressdetails_module_default()).newpressdetail,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (newspressdetails_module_default()).curve,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (newspressdetails_module_default()).content,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
                                className: (newspressdetails_module_default()).customContainer,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        id: "blogdetlsheading",
                                        className: (newspressdetails_module_default()).bg,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                                            className: "justify-content-center",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                                lg: 8,
                                                md: 8,
                                                xs: 12,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: (newspressdetails_module_default()).heading,
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Breadcrumb/* default */.Z, {
                                                            className: (newspressdetails_module_default()).breadcrumb,
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Breadcrumb/* default.Item */.Z.Item, {
                                                                    href: pathCondition ? "/news" : "/blogs",
                                                                    style: {
                                                                        opacity: 0.5
                                                                    },
                                                                    children: pathCondition ? "News and Press" : "Blog"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Breadcrumb/* default.Item */.Z.Item, {
                                                                    href: "",
                                                                    children: [
                                                                        "Detail ",
                                                                        pathCondition ? "News" : "Blog"
                                                                    ]
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                                            children: detailData.title
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                            className: (newspressdetails_module_default()).date,
                                                            children: formatDate(detailData.date)
                                                        })
                                                    ]
                                                })
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        id: "imgdiv",
                                        className: (newspressdetails_module_default()).imgdiv,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                                            className: "justify-content-center",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                                xs: 12,
                                                md: 12,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: (newspressdetails_module_default()).parentMain,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: (newspressdetails_module_default()).first,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                                            src: detailData?.imageUrl,
                                                            alt: detailData.newimageUrl?.alt || "blog-image",
                                                            width: 1170,
                                                            height: 400,
                                                            priority: true,
                                                            isLazyLoad: false
                                                        })
                                                    })
                                                })
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        id: "usersectiondtl",
                                        className: (newspressdetails_module_default()).usersection,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* default */.Z, {
                                            className: (newspressdetails_module_default()).botBorder,
                                            children: [
                                                !isMobile && /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                        className: `${(newspressdetails_module_default())["syj-btn"]} ${applyCtaButtonProps.formClassName}`,
                                                        onClick: ctaBtnClickHandler(applyCtaButtonProps),
                                                        children: detailData?.blogCtaButton?.title ?? "Book Free Study Abroad Counselling"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Col/* default */.Z, {
                                                    lg: 5,
                                                    md: 5,
                                                    sm: 12,
                                                    xs: 12,
                                                    className: (newspressdetails_module_default()).linksClass,
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            children: "Share :"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(components_SocialShareButtons, {
                                                            currentUrl: currentUrl
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: (newspressdetails_module_default())["img-container"],
                                                            onClick: ()=>onClickCopy(),
                                                            ref: target,
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                                                src: "/link.svg",
                                                                width: 40,
                                                                height: 36,
                                                                alt: "link"
                                                            })
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Col/* default */.Z, {
                                                    xs: 12,
                                                    md: 7,
                                                    className: "d-flex justify-content-start",
                                                    children: [
                                                        detailData.profImageUrl && /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                                            src: detailData.profImageUrl,
                                                            width: 75,
                                                            height: 75,
                                                            alt: "proImages"
                                                        }),
                                                        detailData.profName && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            className: (newspressdetails_module_default()).title,
                                                            children: detailData.profName
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    })
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                        className: (newspressdetails_module_default()).customContainer,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* default */.Z, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Col/* default */.Z, {
                                    xl: 8,
                                    lg: 8,
                                    md: 8,
                                    sm: 12,
                                    xs: 12,
                                    className: (newspressdetails_module_default()).padding,
                                    children: [
                                        isMobile && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (newspressdetails_module_default()).prefSourceBtnContainer,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PrefSrcButton/* default */.Z, {})
                                        }),
                                        props?.category === "news" && detailData?.advertisement?.advertisementImg?.url && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (newspressdetails_module_default()).advertisementMobileImage,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_AdvertisementSection, {
                                                matchedAdvertisement: {
                                                    url: detailData?.advertisement?.advertisementImg?.url,
                                                    link: detailData?.advertisement?.link
                                                },
                                                isMobile: true
                                            })
                                        }),
                                        props?.category !== "news" && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (newspressdetails_module_default()).advertisementMobileImage,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_AdvertisementSection, {
                                                matchedAdvertisement: matchedAdvertisement,
                                                isMobile: true
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(IntroAd/* default */.Z, {
                                            introAd: introAd
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: (newspressdetails_module_default()).blogContent,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    id: "sanitizedHeroContent",
                                                    className: (newspressdetails_module_default()).heroContent,
                                                    children: (0,helpers/* parseHeroHTML */.o4)(detailData.intro, 2)
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(LazyReveal/* default */.Z, {
                                                    shimmer: /*#__PURE__*/ (0,jsx_runtime.jsx)(BlogShimmer, {}),
                                                    rootMargin: "-100px",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: (newspressdetails_module_default()).para + ` blogDetails`,
                                                        dangerouslySetInnerHTML: {
                                                            __html: sanitizedContent
                                                        }
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                    xl: 4,
                                    lg: 4,
                                    md: 4,
                                    sm: 4,
                                    xs: 12,
                                    className: `${(newspressdetails_module_default()).padding} ${(newspressdetails_module_default()).positionRelative} d-block d-none d-sm-block d-sm-none d-md-block`,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (newspressdetails_module_default()).relatedBlogDiv,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: (newspressdetails_module_default()).prefSourceBtnContainer,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PrefSrcButton/* default */.Z, {})
                                            }),
                                            props?.category !== "news" && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: (newspressdetails_module_default()).jotForm,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: (newspressdetails_module_default()).jotFormheading,
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                                className: (newspressdetails_module_default()).headingBlogs,
                                                                children: "Want to Study Abroad?"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                className: (newspressdetails_module_default()).subHeading,
                                                                children: "KC can help – Fill in your details and we'll call you back"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(LeadGenForms/* default */.Z, {
                                                        loader: "shimmer",
                                                        mode: "inline",
                                                        url: "https://crm.coursefinder.ai" + "/" + (pathCondition ? "main-enquiry-form" : "blogs-open-enquiry-form-detailed-blogs-pages"),
                                                        wrapperClass: pathCondition ? (newspressdetails_module_default()).inLineFormNews : (newspressdetails_module_default()).inLineFormBlogs
                                                    })
                                                ]
                                            }),
                                            props?.category === "news" && detailData?.advertisement?.advertisementImg?.url && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: `${(newspressdetails_module_default()).advertisement} ${(newspressdetails_module_default()).advertisementNews}`,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_AdvertisementSection, {
                                                    matchedAdvertisement: {
                                                        url: detailData?.advertisement?.advertisementImg?.url,
                                                        link: detailData?.advertisement?.link
                                                    },
                                                    isMobile: false
                                                })
                                            }),
                                            props?.category === "news" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(LazyReveal/* default */.Z, {
                                                onVisible: onLatestNewsVisible,
                                                rootMargin: "100px",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(News_LatestNews, {
                                                    latestNews: latestNews.slice(0, 2),
                                                    isLoading: isLatestNewsLoading
                                                })
                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(components_RelatedBlogs, {
                                                categoryBlogs: categoryBlogs,
                                                pathCondition: pathCondition,
                                                detailData: detailData,
                                                styles: (newspressdetails_module_default())
                                            }),
                                            props?.category !== "news" && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: (newspressdetails_module_default()).advertisement,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_AdvertisementSection, {
                                                    matchedAdvertisement: matchedAdvertisement,
                                                    isMobile: false
                                                })
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                        className: `${(newspressdetails_module_default()).customContainer} ${(newspressdetails_module_default()).NeedGuidance}`,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NeedGuidance/* default */.Z, {
                            button2Data: {
                                title: detailData?.needGuidance?.button2?.title,
                                link: detailData?.needGuidance?.button2?.link,
                                formId: detailData?.meta?.jotforms[0]?.jotformid || (detailData?.needGuidance?.button2?.toOnboardingEnabled ? undefined : "blogs-open-enquiry-form-detailed-blogs-pages"),
                                toOnboardingEnabled: detailData?.needGuidance?.button2?.toOnboardingEnabled,
                                lookingForCoaching: detailData?.needGuidance?.button2?.lookingForCoaching,
                                nearestOffice: detailData?.needGuidance?.button2?.nearestOffice
                            }
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                        className: (newspressdetails_module_default()).customContainer,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (newspressdetails_module_default()).horizonatalLine
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        id: "blgrealated",
                        className: (newspressdetails_module_default()).latestNew,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
                            className: (newspressdetails_module_default()).customContainer,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (newspressdetails_module_default()).heading,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("h2", {
                                            children: [
                                                "Latest ",
                                                pathCondition ? "News" : "Blogs"
                                            ]
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (newspressdetails_module_default()).news,
                                    children: pathCondition ? /*#__PURE__*/ (0,jsx_runtime.jsx)(BlogDetailPage_NewsList, {
                                        sliderSettings: settings,
                                        styles: (newspressdetails_module_default()),
                                        detailData: detailData,
                                        pathCondition: pathCondition,
                                        latestNews: latestNews,
                                        isLoading: isLatestNewsLoading,
                                        onVisible: onLatestNewsVisible
                                    }) : // Render blogs
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(BlogDetailPage_BlogsList, {
                                        detailData: detailData,
                                        styles: (newspressdetails_module_default()),
                                        pathCondition: pathCondition,
                                        settings: settings
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Overlay/* default */.Z, {
                        target: target.current,
                        show: isCopied,
                        placement: "bottom",
                        rootClose: true,
                        onHide: ()=>setIsCopied(false),
                        children: (props)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* default */.Z, {
                                id: "overlay-example",
                                ...props,
                                children: "Link copied!"
                            })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var BlogDetailPage = (NewsAndPressDetailPage);


/***/ }),

/***/ 70710:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ LazyReveal; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
"use client";


const DefaultShimmer = ()=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "animate-pulse bg-gray-300 h-6 w-full rounded-lg"
    });
function LazyReveal({ children , shimmer , rootMargin ="0px" , threshold =0.1 , className , onVisible , id , style  }) {
    const { 0: visible , 1: setVisible  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const wrapperRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    const observerRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (!wrapperRef.current) return;
        observerRef.current = new IntersectionObserver((entries)=>{
            const entry = entries[0];
            if (entry.isIntersecting) {
                setVisible(true);
                onVisible && onVisible();
                observerRef.current?.disconnect();
            }
        }, {
            rootMargin,
            threshold
        });
        observerRef.current.observe(wrapperRef.current);
        return ()=>{
            observerRef.current?.disconnect();
        };
    }, [
        rootMargin,
        threshold
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        ref: wrapperRef,
        className: className,
        id: id,
        style: style,
        children: visible ? children : shimmer || /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(DefaultShimmer, {})
    });
}


/***/ }),

/***/ 84623:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_bootstrap_Container__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(10682);
/* harmony import */ var react_bootstrap_Row__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(34051);
/* harmony import */ var react_bootstrap_Col__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(31555);
/* harmony import */ var _styles_NeedGuidance_module_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(65822);
/* harmony import */ var _styles_NeedGuidance_module_scss__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_styles_NeedGuidance_module_scss__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _utils_applyCtaButtonProps__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(78409);
/* harmony import */ var _utils_b2c_sourceTracking__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(3265);
/* harmony import */ var _utils_b2c_constants__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(90017);










const NeedGuidance = ({ classname , button2Data  })=>{
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    const applyCtaButtonProps1 = (0,_utils_applyCtaButtonProps__WEBPACK_IMPORTED_MODULE_3__/* .getOnboardingOrFormCtaProps */ .J)(router, {
        btnLink: button2Data?.link,
        formId: button2Data?.formId,
        toOnboardingEnabled: button2Data?.toOnboardingEnabled,
        sourceUrl:  true ? window.location.pathname : 0
    });
    const ctaBtnClickHandler = (applyCtaButtonProps)=>(e)=>{
            if (applyCtaButtonProps.mode === "onboarding") {
                (0,_utils_b2c_sourceTracking__WEBPACK_IMPORTED_MODULE_4__/* .persistSourceContext */ .jW)({
                    sourceUrl: window.location.href,
                    primarySource: _utils_b2c_constants__WEBPACK_IMPORTED_MODULE_5__/* .PRIMARY_SOURCE_B2C_WIDGET */ .ov,
                    fifthStepVisible: button2Data?.nearestOffice ?? true,
                    coachingVisible: button2Data?.lookingForCoaching ?? true
                });
            }
            applyCtaButtonProps.onClick?.(e);
        };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            id: "need-guidance",
            className: (_styles_NeedGuidance_module_scss__WEBPACK_IMPORTED_MODULE_6___default().studentFooter),
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Container__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Row__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Col__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: (_styles_NeedGuidance_module_scss__WEBPACK_IMPORTED_MODULE_6___default().session),
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                        style: {
                                            fontSize: "26px"
                                        },
                                        children: "Need guidance? Let us help you."
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: (_styles_NeedGuidance_module_scss__WEBPACK_IMPORTED_MODULE_6___default().anchor),
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                            href: "/contact-us",
                                            className: (_styles_NeedGuidance_module_scss__WEBPACK_IMPORTED_MODULE_6___default().btTranparent),
                                            children: "Contact Us"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: `${(_styles_NeedGuidance_module_scss__WEBPACK_IMPORTED_MODULE_6___default().enquireBtn)} ${classname || ""} ${applyCtaButtonProps1.formClassName}`,
                                            onClick: button2Data ? ctaBtnClickHandler(applyCtaButtonProps1) : undefined,
                                            children: button2Data?.title ?? "Enquire Now"
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                })
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (NeedGuidance);


/***/ }),

/***/ 20283:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ PrefSrcButton_PrefSrcButton; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/script.js
var script = __webpack_require__(4298);
var script_default = /*#__PURE__*/__webpack_require__.n(script);
// EXTERNAL MODULE: ./components/UI/PrefSrcButton/PrefSrcButton.module.scss
var PrefSrcButton_module = __webpack_require__(99100);
var PrefSrcButton_module_default = /*#__PURE__*/__webpack_require__.n(PrefSrcButton_module);
;// CONCATENATED MODULE: ./components/UI/Icons/GoogleIcon.tsx


const GoogleIcon = ({ width =24 , height =24  })=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M24 12.2728C24 11.4219 23.9221 10.6037 23.7774 9.81826H12.2449V14.4601H18.8349C18.551 15.9601 17.6883 17.231 16.3915 18.0819V21.0928H20.3488C22.6642 19.0037 24 15.9274 24 12.2728Z",
                fill: "#4285F4"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M12.2449 24C15.551 24 18.3228 22.9255 20.3488 21.0928L16.3915 18.0819C15.295 18.8019 13.8924 19.2273 12.2449 19.2273C9.05567 19.2273 6.35623 17.1164 5.39333 14.28H1.30242V17.3891C3.31726 21.3109 7.45827 24 12.2449 24Z",
                fill: "#34A853"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M5.39333 14.28C5.14843 13.56 5.00928 12.791 5.00928 12.0001C5.00928 11.2092 5.14843 10.4401 5.39332 9.72007V6.61097H1.30241C0.473099 8.23098 0 10.0637 0 12.0001C0 13.9364 0.473104 15.7691 1.30242 17.3891L5.39333 14.28Z",
                fill: "#FBBC05"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M12.2449 4.77273C14.0427 4.77273 15.6568 5.37818 16.9258 6.56728L20.4379 3.12546C18.3173 1.18909 15.5455 0 12.2449 0C7.45827 0 3.31726 2.68915 1.30241 6.61097L5.39332 9.72007C6.35622 6.8837 9.05567 4.77273 12.2449 4.77273Z",
                fill: "#EA4335"
            })
        ]
    });
};
/* harmony default export */ var Icons_GoogleIcon = (GoogleIcon);

;// CONCATENATED MODULE: ./components/UI/PrefSrcButton/PrefSrcButton.tsx





const FALLBACK_URL = "https://www.google.com/preferences/source?q=studies-overseas.com";
const PrefSrcButton = ({ style , variant ="outline"  })=>{
    const apiRef = (0,react.useRef)(null);
    (0,react.useEffect)(()=>{
        window.PREFERRED_SOURCE = window.PREFERRED_SOURCE || [];
        window.PREFERRED_SOURCE.push((api)=>{
            api.init({
                theme: "light",
                lang: "en"
            });
            apiRef.current = api;
        });
    }, []);
    const handleClick = ()=>{
        if (apiRef.current) {
            apiRef.current.addPreferredSource();
            return;
        }
        window.open(FALLBACK_URL, "_blank", "noopener,noreferrer");
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
                id: "google-preferred-sources",
                src: "https://news.google.com/swg/js/v1/publisher.js",
                strategy: "lazyOnload",
                "preferred-sources-control": "manual"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                type: "button",
                className: `${(PrefSrcButton_module_default()).prefSourceBtn} ${variant === "filled" ? (PrefSrcButton_module_default())["filled-btn"] : ""}`,
                style: style,
                onClick: handleClick,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons_GoogleIcon, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: "Add KC as Preferred Source on Google"
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var PrefSrcButton_PrefSrcButton = (PrefSrcButton);


/***/ }),

/***/ 41472:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _CustomImage__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(45992);
/* harmony import */ var _IntroAd_module_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(76343);
/* harmony import */ var _IntroAd_module_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_IntroAd_module_scss__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _utils_helpers__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(32866);





const IntroAd = ({ introAd  })=>{
    if (!introAd?.desktopImg?.url) return null;
    const formClass = introAd?.link ? "" : (0,_utils_helpers__WEBPACK_IMPORTED_MODULE_3__/* .isFrappeOrJotFormClass */ .gd)(introAd?.formId ?? "");
    const image = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_CustomImage__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        src: introAd.desktopImg.url,
        height: 264,
        width: 975,
        alt: "advertisement",
        isLazyLoad: true,
        priority: false
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: `${(_IntroAd_module_scss__WEBPACK_IMPORTED_MODULE_4___default().introAd)} ${formClass}`,
        children: introAd?.link ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
            href: introAd.link,
            target: "_blank",
            rel: "noopener noreferrer",
            "aria-label": "advertisement",
            children: image
        }) : image
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (IntroAd);


/***/ }),

/***/ 14523:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
// hooks/useIsMobile.ts

const useIsMobile = (breakpoint = 768)=>{
    const { 0: isMobile , 1: setIsMobile  } = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{
        const mediaQuery = window.matchMedia(`(max-width: ${breakpoint}px)`);
        const handleChange = (e)=>{
            setIsMobile(e.matches);
        };
        // Set initial value
        setIsMobile(mediaQuery.matches);
        // Listen for changes
        mediaQuery.addEventListener("change", handleChange);
        return ()=>{
            mediaQuery.removeEventListener("change", handleChange);
        };
    }, [
        breakpoint
    ]);
    return isMobile;
};
/* harmony default export */ __webpack_exports__["Z"] = (useIsMobile);


/***/ }),

/***/ 40607:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
const DEFAULT_TIMEOUT_MS = 8000;
const fetchUtil = async (url, method, body, ctype, useToken, useHeaders, token, timeoutMs = DEFAULT_TIMEOUT_MS)=>{
    const controller = new AbortController();
    const timer = setTimeout(()=>controller.abort(), timeoutMs);
    let options = {};
    if (method === "GET") {
        options = useHeaders ? {
            method,
            signal: controller.signal
        } : {
            method,
            headers: requestHeaders(ctype, useToken, token),
            signal: controller.signal
        };
    } else {
        options = {
            method,
            headers: requestHeaders(ctype, useToken, token),
            body: JSON.stringify(body),
            signal: controller.signal
        };
    }
    try {
        const res = await fetch(url, options);
        return await parseStatus(res.status, res);
    } finally{
        clearTimeout(timer);
    }
};
const parseStatus = (status, res)=>{
    return new Promise((resolve, reject)=>{
        if (status >= 200 && status < 300) {
            if (res.url.indexOf(".html") > -1) {
                return resolve(res);
            }
            res.json().then((response)=>resolve(response));
        } else {
            res.json().then((response)=>reject(response));
        }
    });
};
const requestHeaders = (ctype, useToken, token)=>{
    return useToken ? {
        "Content-Type": ctype || "application/json",
        Authorization: token
    } : {
        "Content-Type": ctype || "application/json"
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (fetchUtil);


/***/ }),

/***/ 37948:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"card":"CardShimmer_card__z7wsp","image":"CardShimmer_image__YOlAY"};

/***/ }),

/***/ 88526:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"hide-scrollbar":"LatestNews_hide-scrollbar__w7ivj","latest-news-container":"LatestNews_latest-news-container__tH_PB","latest-news-heading":"LatestNews_latest-news-heading__H3X2o","latest-news-card":"LatestNews_latest-news-card__isMSk","latest-news-image":"LatestNews_latest-news-image__hEuLI","latest-news-body":"LatestNews_latest-news-body__B_FU8","latest-news-category":"LatestNews_latest-news-category__GXV5_","latest-news-description":"LatestNews_latest-news-description__j3sIn","latest-news-date":"LatestNews_latest-news-date__3dTta"};

/***/ }),

/***/ 99100:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"hide-scrollbar":"PrefSrcButton_hide-scrollbar__vEUyX","prefSourceBtn":"PrefSrcButton_prefSourceBtn__iDh8f","filled-btn":"PrefSrcButton_filled-btn__OHRQ4"};

/***/ }),

/***/ 76343:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"hide-scrollbar":"IntroAd_hide-scrollbar__oEPzx","introAd":"IntroAd_introAd__dd9JC"};

/***/ }),

/***/ 65822:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"studentFooter":"NeedGuidance_studentFooter__5o74_","session":"NeedGuidance_session__8Zc7c","anchor":"NeedGuidance_anchor__9XZiq","enquireBtn":"NeedGuidance_enquireBtn__u9ZDM","btTranparent":"NeedGuidance_btTranparent__iNGT9"};

/***/ }),

/***/ 16083:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"hide-scrollbar":"newspressdetails_hide-scrollbar__OcRNu","newpress":"newspressdetails_newpress__3ad66","curve":"newspressdetails_curve__4E8Zs","content":"newspressdetails_content__VVn3D","heading":"newspressdetails_heading__IjaA_","enquirebtn":"newspressdetails_enquirebtn__mXWLB","servContent":"newspressdetails_servContent__3Ryg8","latestNew":"newspressdetails_latestNew__j4nmx","news":"newspressdetails_news__0_Ha4","card":"newspressdetails_card__323YE","cardBody":"newspressdetails_cardBody__IlFeD","cardTitile":"newspressdetails_cardTitile__TWVBu","viewMore":"newspressdetails_viewMore__iKQh0","FeaturedNews":"newspressdetails_FeaturedNews__0Iuui","WhyKc":"newspressdetails_WhyKc__1mZj7","img":"newspressdetails_img__UMocA","allnews":"newspressdetails_allnews___XffD","newpressdetail":"newspressdetails_newpressdetail__ifNLs","breadcrumb":"newspressdetails_breadcrumb__QgYAO","date":"newspressdetails_date__O7k_b","bg":"newspressdetails_bg__8tKM4","imgdiv":"newspressdetails_imgdiv__ecIf_","parentMain":"newspressdetails_parentMain__3zgmL","first":"newspressdetails_first__f9IhD","usersection":"newspressdetails_usersection__sQfCj","title":"newspressdetails_title__Ow6wJ","botBorder":"newspressdetails_botBorder__6bWsq","syj-btn":"newspressdetails_syj-btn__ibQ_I","heroContent":"newspressdetails_heroContent__f51r5","para":"newspressdetails_para__2jlNV","cardImg":"newspressdetails_cardImg__12we0","shortDescription":"newspressdetails_shortDescription__QxjQF","bottom":"newspressdetails_bottom__J59at","linksClass":"newspressdetails_linksClass__ZtvYg","img-container":"newspressdetails_img-container__UiJsJ","customContainer":"newspressdetails_customContainer__1c95q","relatedBlogDiv":"newspressdetails_relatedBlogDiv__O1s8G","relatedBlogsBox":"newspressdetails_relatedBlogsBox__dfStC","relatedBlogImg":"newspressdetails_relatedBlogImg__lipA9","headingBlogs":"newspressdetails_headingBlogs__Y2Ecr","padding":"newspressdetails_padding__YW8lr","jotForm":"newspressdetails_jotForm__IXfoa","advertisement":"newspressdetails_advertisement__UGiAb","box":"newspressdetails_box__FPwzS","advertisementNews":"newspressdetails_advertisementNews__65GLI","prefSourceBtnContainer":"newspressdetails_prefSourceBtnContainer__Dve1M","blogContent":"newspressdetails_blogContent__bVu0N","sliderDots":"newspressdetails_sliderDots__QA6us","slick-active":"newspressdetails_slick-active__xYRnk","NeedGuidance":"newspressdetails_NeedGuidance__K3B12","horizonatalLine":"newspressdetails_horizonatalLine__opN78","arrowsClasses":"newspressdetails_arrowsClasses__OPHqL","btcircle":"newspressdetails_btcircle__nZ8mj","advertisementMobileImage":"newspressdetails_advertisementMobileImage__oW7Sh","inLineFormNews":"newspressdetails_inLineFormNews__byoVR","inLineFormBlogs":"newspressdetails_inLineFormBlogs__FEwuU","jotFormheading":"newspressdetails_jotFormheading__6ul62","subHeading":"newspressdetails_subHeading__oZRHY","positionRelative":"newspressdetails_positionRelative__i3hKp","sanitizedHeroContent":"newspressdetails_sanitizedHeroContent__ggkeM","centerIcon":"newspressdetails_centerIcon__Xx340"};

/***/ })

}]);